export const PORTFOLIO_DATA = {
	LINKED_IN_URL: "https://www.linkedin.com/in/oyintare-ebelo-4850a6201/",
	GITHUB_URL: "https://github.com/TareHimself",
	YOUTUBE_URL: "https://www.youtube.com/@TareEbelo",
	UNREAL_ENGINE_URL:
		"https://www.unrealengine.com/marketplace/en-US/profile/TareE",
};
